<script>
	export let dataSurveyInfo = [];
	import {Notebook} from '@manaakiwhenua/frag-svelte/src/index';
	import {default as mapUnitFactsheet} from '../notebooks/@ridgenb/map-unit-factsheet';

	//let cells = ['displayMap'];
	let cells = ['surveyInfoDesc', 'surveyInfo'];
	//let cells = ['displayTextureGraph'];
	$: overrides = new Map([['dataSurveyInfo', dataSurveyInfo]]);
</script>

<Notebook notebook={mapUnitFactsheet} cells={cells} overrides={overrides}></Notebook>